import React from 'react'

export default function NotFoundPage() {
    return (
        <div>
            Page Not Found
        </div>
    )
}
